import React from "react";
import { mainTable } from "../css/Common";




const AddScreenTitle = ({ addScreenTitle, updateScreenTitle, title,sendTitle}) => {
  return (
    <div class={mainTable.addScreenTitle}>
      {addScreenTitle && (
        <div className={mainTable.addScreenTitle}>{`${title} - Add`}</div>
      )}

      {updateScreenTitle && (
        <div className={mainTable.addScreenTitle}>{`${title} - Edit`}</div>
      )}
      {sendTitle && (
        <div className={mainTable.addScreenTitle}>{`${title} - Send`}</div>
      )}
    </div>
  );
};

export default AddScreenTitle;
